import React, { Component } from 'react'
import { Table, Popover } from 'antd'
import { bytesToSize } from '../../../../utils'
import * as moment from 'moment'
import { api } from '../../../../services'

class FileThumb extends Component {
  state = {
    thumb: null
  }

  componentDidMount () {
    const { guid } = this.props

    api.storage.getThumbnail(guid)
      .then((response) => {
        if (response.data.size > 0) {
          this.setState({
            thumb: window.URL.createObjectURL(new Blob([response.data]))
          })
        }
      })
      .catch(error => console.log(error))
  }

  render () {
    const { extension } = this.props
    const { thumb } = this.state

    const preview = <div style={{ width: '24rem' }}>
      <img src={thumb} alt='' style={{ display: 'block', width: '100%', height: 'auto' }} />
    </div>

    if (thumb === null) {
      return <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '4rem', height: '4rem', background: '#f8f8f8', backgroundImage: 'url(' + thumb + ')', backgroundRepeat: 'no-repeat', backgroundPosition: 'center', backgroundSize: 'cover' }}>
        <div style={{ fontWeight: '500', fontSize: '1rem' }}>{ extension.toUpperCase() }</div>
      </div>
    }

    return <Popover placement='rightTop' title={''} content={preview} trigger='click'>
      <div style={{ width: '4rem', height: '4rem', background: '#f8f8f8', backgroundImage: 'url(' + thumb + ')', backgroundRepeat: 'no-repeat', backgroundPosition: 'center', backgroundSize: 'cover' }} />
    </Popover>
  }
}

const columns = [{
  title: 'Name',
  dataIndex: 'name',
  key: 'NAME',
  width: '50%',
  sorter: true,
  render: (value, record) => {
    return (
      <div className='user-cell' style={{ display: 'flex' }}>
        <div className='user-cell__thumb' style={{ marginRight: '2rem' }}>
          <FileThumb guid={record.guid} extension={record.extension} />
        </div>
        <div className='user-cell__info'>
          <div className='user-cell__name'>{`${value}.${record.extension}`}</div>
          { record.tags.length > 0
            ? <div className='user-cell__groups'>
              { record.tags.map((tag, index) => <div key={index} className='user-cell__group'>{ tag.value }</div>) }
            </div> : null }
        </div>
      </div>
    )
  }
}, {
  title: 'Size',
  dataIndex: 'size',
  key: 'SIZE',
  width: '25%',
  sorter: true,
  render: (value) => {
    return bytesToSize(value)
  }
}, {
  title: 'Modified Date',
  dataIndex: 'timestampModified',
  defaultSortOrder: 'descend',
  key: 'DATE',
  width: '25%',
  sorter: true,
  render: (value) => {
    return moment(value).format('YYYY-MM-DD HH:mm:ss')
  }
}]

export default class extends Component {
  handleRowSelect = (keys, rows) => {
    this.props.setTable(keys, rows)
  }

  render () {
    const { keys } = this.props.storage.table
    const loading = this.props.storage.isFetching
    const { storage, setFilterTable } = this.props

    const rowSelection = {
      selectedRowKeys: keys,
      onChange: this.handleRowSelect
    }

    return <Table
      loading={loading}
      rowKey={record => record.id}
      rowSelection={rowSelection}
      dataSource={storage.data.files}
      columns={columns}
      onChange={(...params) => {
        const orderTypes = {
          ascend: 'ASC',
          descend: 'DESC'
        }
        const page = params[0].current - 1
        const pageSize = params[0].pageSize
        const sort = params[2].columnKey
        const order = orderTypes[params[2].order]

        setFilterTable(page, pageSize, sort, order)
      }}
      pagination={{
        current: storage.filters.page + 1,
        total: storage.data.nestedCount,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50'],
        pageSize: storage.filters.pageSize
      }}
    />
  }
}



// WEBPACK FOOTER //
// ./src/views/Content/components/TableContent/TableContent.jsx